import { CustomFieldListItemProps } from "@/components/custom-field/list-item/custom-field-list-item.type.ts";
import { CustomFieldFileItem } from "@/components/custom-field/CustomFieldFileItem.tsx";
import { ListItem, Stack } from "@skailer-com/uikit";

export function CustomFieldListItemFile({ field, fieldValue, label }: CustomFieldListItemProps) {
  const titleSlot = fieldValue?.value_file ? (
    <Stack className={"pt-2"}>
      <CustomFieldFileItem file={fieldValue.value_file} />
    </Stack>
  ) : (
    <>{"-"}</>
  );
  return <ListItem preTitle={label ?? field.title} titleSlot={titleSlot} />;
}
